import { ErrorHandler, Injectable, inject, InjectionToken } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { ErrorProcessorConfig } from './error-handler.types';

/**
 * Token de inyección para la configuración del environment.
 */
export const ERROR_HANDLER_CONFIG = new InjectionToken<Partial<ErrorProcessorConfig>>(
  'ERROR_HANDLER_CONFIG',
);

/**
 * Servicio de manejo de errores de Angular.
 * Implementa la interfaz ErrorHandler de Angular.
 * El enriquecimiento de logs se hace automáticamente en CustomNGXLoggerServerService.
 */
@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService implements ErrorHandler {
  private logger = inject(NGXLogger);

  /**
   * Método principal de manejo de errores (implementa ErrorHandler de Angular).
   */
  handleError(error: any): void {
    // Solo loguear el error
    // CustomNGXLoggerServerService se encarga de enriquecerlo automáticamente
    this.logger.error(error);
  }
}
